import { useMemo } from "react";

import { useChecksCountUserQrsQuery } from "@/graphql/checks/checks.hooks";

function useChecksCountUserQrs() {
  const { data, loading, error } = useChecksCountUserQrsQuery();
  const WARNING_COUNT = 9900;
  const LIMIT = 10000;
  const countUserQrs = data?.checks.countUserQrs ?? 0;

  return useMemo(
    () => ({
      countUserQrs,
      loading,
      error,
      showWarningAlert: countUserQrs >= WARNING_COUNT && countUserQrs < LIMIT,
      limitReached: countUserQrs >= LIMIT,
      qrLimit: LIMIT,
      warningCount: WARNING_COUNT,
    }),
    [countUserQrs, error, loading]
  );
}

export default useChecksCountUserQrs;
